<template>
    <div class="input-wrapper" :class="{ 'error': this.error }">
        <input v-if="type === 'checkbox'" :id="computedId" :ref="REF_INPUT" :checked="modelValue"
            @change="handleCheckboxChange" :type="type" :disabled="disabled" v-bind="$attrs" />

        <input v-else :id="computedId" :ref="REF_INPUT" :value="modelValue" @input="handleInput"
            :autocomplete="type === 'password' ? 'new-password' : 'off'" :type="type"
            :min="type === 'number' || type === 'range' ? min : undefined" :max="type === 'range' ? max : undefined"
            :step="type === 'range' ? step : undefined" :placeholder="placeholder" :disabled="disabled"
            :style="{ border: borderless ? 'none transparent' : '', outline: borderless ? 'none' : '' }" v-bind="$attrs" />

        <label :for="computedId" @click="handleLabelClick" class="input-label" v-if="label">{{ this.label }} {{ required ?
            '*' : '' }}</label>

        <div class="error-container">
            <label class="error-label" :class="{ 'show': error }">{{ this.errortext }}</label>
        </div>
    </div>
</template>

<script>
const REF_INPUT = 'input'

export default {
    name: 'text-input',
    props: {
        modelValue: {
            type: [String, Number, Boolean, Array],
            default: ''
        },
        type: {
            type: String,
            default: 'text',
            validator: value => {
                // Allow only specific types
                return ['text', 'password', 'checkbox', 'number', 'range'].includes(value)
            }
        },

        placeholder: {
            type: String,
            default: ' ' // is used to trigger the floating label so it can not be empty
        },
        disabled: Boolean,
        label: String,
        required: Boolean,
        error: Boolean,
        errortext: String,
        min: Number,
        max: Number,
        step: Number,
        inputId: String,
        idStub: String,
        borderless: {
            type: [Boolean, Object],
            default: false
        },
    },
    data() {
        return {
            REF_INPUT
        }
    },
    computed: {
        computedId: function () {
            const externalId = this.inputId || ''
            const stub = this.idStub ? '-' + this.idStub : ''
            const id = `input-${externalId}${stub}`
            // only set the id if an externalId and/or sub was given
            // else there will be inputs with the same id and the label
            // will only respond to the first input with the given id!
            return id !== 'input-' ? id : undefined
        }
    },
    methods: {
        handleInput: function (event) {
            if (event.target.id === 'speedInput') {
                this.checkSpeed(event)
            }
            this.$emit('update:modelValue', event.target.value)
        },
        clicked: function (event) {
            this.$emit('click', event)
        },
        handleLabelClick() {
            this.$refs[REF_INPUT].focus()
        },
        handleCheckboxChange(event) {
            this.$emit('update:modelValue', event.target.checked)
        },
        checkSpeed(event) {
            let speed = parseInt(event.target.value)
            if (speed > 100) {
                event.target.value = 100
            } else if (speed < -100) {
                event.target.value = -100
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
    position: relative;
    padding: 24px 0 8px;

    &.error {
        :deep(*) {
            color: red;
        }

        >input {
            border: 1px solid red;
        }
    }

    >.input-label {
        color: rgba(0, 0, 0, 0.6);
        position: absolute;
        font-size: 16px;
        font-weight: 400;
        left: 10px;
        top: 24px;
        transition: .2s all;
        height: 10px;
        line-height: 10px;

        &:hover {
            cursor: text;
        }
    }

    >input {
        width: 100%;
        height: 30px;
        box-sizing: border-box;
        font-size: 17px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.87);
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        background-color: unset;
        border: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.6);

        &:focus {
            outline: none;
        }

        &::placeholder {
            font-size: 1em;
        }

        &:disabled {
            border-color: #ddd;
            cursor: not-allowed;
        }

        &:not(:placeholder-shown),
        &:focus:not(:read-only) {
            &+.input-label {
                font-size: 1em;
                top: 4px;
                left: 0px;
            }
        }
    }

    >.error-container {
        min-height: 15px;
        margin-top: 3px;
        padding-left: 10px;
        color: red;
        text-align: left;

        >.error-label {
            visibility: hidden;

            &.show {
                visibility: visible;
            }
        }
    }
}
</style>